import Vue from "vue";
import router from "./router";
import { storeSearch, storeMyPages } from "./store";
import ui from "./ui";

// --- APPS & STAND ALONE COMPONENT REFS
window.vm = window.vm || { role: "public" }; // researcher || member || public
window.vm.mode = process.env.NODE_ENV;

// --- THIRD PARTY COMPONENTS
import VModal from "vue-js-modal";
Vue.use(VModal);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import Slick from "vue-slick";
Vue.component("Slick", Slick);

import da from "vee-validate/dist/locale/da";
import en from "vee-validate/dist/locale/en";
import VeeValidate, { Validator } from "vee-validate";

// QuickFix for Validator
var validatorMetaNodeForCulture = document.querySelector('meta[name="culture"]');
var validatorCulture = validatorMetaNodeForCulture !== null ? validatorMetaNodeForCulture.content : "da-DK";
if (validatorCulture === "da-DK") {
    Validator.localize("da", da);
    Vue.use(VeeValidate, { locale: "da" });
} else {
    Validator.localize("en", en);
    Vue.use(VeeValidate, { locale: "en" });
}

// --- SCROLLING FEATURE
var scrollTopVal = 50;
var html = document.documentElement;
window.onscroll = function (e) {
    var y = window.scrollY;
    if (y > scrollTopVal && !html.classList.contains('scrolled')) {
        html.classList.add('scrolled');
    } else if (y < scrollTopVal && html.classList.contains('scrolled')) {
        html.classList.remove('scrolled');
    }
}

// --- CUSTOM COMPONENTS
Vue.directive('click-outside', {
    bind() {
        console.log("this.el");
        this.event = event => this.vm.$emit(this.expression, event)
        this.el.addEventListener('click', this.stopProp)
        document.body.addEventListener('click', this.event)
    },
    unbind() {
        if (this.el !== undefined) {
            this.el.removeEventListener('click', this.stopProp)
        }
        document.body.removeEventListener('click', this.event)
    },

    stopProp(event) { event.stopPropagation() }
});

import FocusLock from "./components/Lock.vue";
Vue.component("FocusLock", FocusLock);

import Dropdown from "./components/Dropdown.vue";
Vue.component("Dropdown", Dropdown);

import GenericErrorMessage from "./components/GenericErrorMessage.vue";
Vue.component("GenericErrorMessage", GenericErrorMessage);

import SearchFilter from "./components/jobeffects-search/SearchFilter.vue";
Vue.component("SearchFilter", SearchFilter);

import Buttons from "./components/Buttons.vue";
Vue.component("Buttons", Buttons);

import Effects from "./components/jobeffects-search/Effects.vue";
Vue.component("Effects", Effects);

import DoughnutChart from "./components/DoughnutChart";
Vue.component("DoughnutChart", DoughnutChart);

import EffectLabel from "./components/EffectLabel";
Vue.component("EffectLabel", EffectLabel);

import StudyResult from "./components/my-pages/StudyResult";
Vue.component("StudyResult", StudyResult);

import Comments from "./components/my-pages/Comments";
Vue.component("Comments", Comments);

import EditStudyFormElements from "./components/my-pages/EditStudyFormElements";
Vue.component("EditStudyFormElements", EditStudyFormElements);

// --- MIXED COMPONENTS (in-dom templates)
import Login from "./mixed-components/Login.js";
if (document.getElementById("loginModal") !== null) {
    window.vm.login = Login.getInstance();
}

import Hero from "./mixed-components/Hero.js";
if (document.getElementsByClassName("hero").length > 0) {
    window.vm.hero = Hero.getInstance();
}

import Entrances from "./mixed-components/Entrances.js";
if (document.getElementsByClassName("entrances").length > 0) {
    window.vm.entrances = Entrances.getInstance(validatorCulture);
}
// import Topical from "./mixed-components/Topical.js";
// if (document.getElementById("topical") !== null) {
//     window.vm.topical = Topical.getInstance();
// }

// --- DIRECTIVES:
import { Focus, Floatable } from "./directives/directives.js";
Vue.directive("focus", Focus);
Vue.directive("floatable", Floatable);

// FILTERS:
import { dateFilter } from "./filters/filters.js";
Vue.filter("formatDate", dateFilter);

Vue.config.productionTip = false;

// --- APPS WITH ROUTING AND STORE
import jobEffectsApp from "./app_JobEffects.vue";
if (document.getElementById("jobeffectsApp") !== null) {
    window.vm.jobEffectsApp = new Vue({
        el: "#jobeffectsApp",
        router: router,
        store: storeSearch,
        template: "<jobEffectsApp/>",
        components: { jobEffectsApp }
    });
}

import studySearchApp from "./app_studySearch.vue";
if (document.getElementById("studySearchApp") !== null) {
    window.vm.studySearchApp = new Vue({
        el: "#studySearchApp",
        router: router,
        store: storeSearch,
        template: "<studySearchApp/>",
        components: { studySearchApp }
    });
}

import myPageApp from "./app_MyPageApp.vue";
if (document.getElementById("myPageApp") !== null) {
    window.vm.studySearchApp = new Vue({
        el: "#myPageApp",
        router: router,
        store: storeMyPages,
        template: "<myPageApp/>",
        components: { myPageApp }
    });
}

// --- UI for toggling menu etc.
ui.init();



// WEBPACK FOOTER //
// ./src/main.js